export default {"src":"/_next/static/media/rugby.a5ea092e.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};